import { Organization } from './api';
// This constant is what the "organizationId" path parameter is set to when the user selects "all
// organizations" in the organization selector.
//
// This means any list views in the app will show data for all organizations.
export const ALL_ORGANIZATIONS = 'all';

// A type to represent the organization parameter in a page's path.
export type OrganizationIdOrAll = Organization['id'] | typeof ALL_ORGANIZATIONS;

export function deserializeOrganization(
  organizationIdOrAll: OrganizationIdOrAll,
): Organization['id'] | null {
  return organizationIdOrAll === ALL_ORGANIZATIONS ? null : organizationIdOrAll;
}
